import { Controller, PlayerDirection } from "./Controller";
import { Signal0 } from "@/js/util/event/Signal0";
import { SignalConnection } from "@/js/util/event/SignalConnection";
import { Value } from "@/js/util/Value";
import { Engine } from "@/game/libs/engine/engine";

export default class ControllerDesktop implements Controller {
  onJump: Signal0;
  onFace: Value<PlayerDirection>;

  constructor() {
    this.onJump = new Signal0();
    this.onFace = new Value<PlayerDirection>(PlayerDirection.FACE_UP);
    this._onKeyDownSignal = Engine.keyboard.down.connect(
      this.onKeyDown.bind(this)
    );
    this._onKeyUpSignal = Engine.keyboard.up.connect(this.onKeyUp.bind(this));
    this._isJumping = false;
  }

  reset(): void {
    this.onFace._ = PlayerDirection.FACE_UP;
  }

  onKeyDown(e: KeyboardEvent) {
    var keycode: KeyCode = e.keyCode;
    switch (keycode) {
      case KeyCode.UP_ARROW:
        e.preventDefault();
        this.handleUp();

        break;
      case KeyCode.DOWN_ARROW:
        e.preventDefault();
        this.onFace._ = PlayerDirection.FACE_DOWN;
        break;
      case KeyCode.LEFT_ARROW: {
        e.preventDefault();
        this.handleLeft();
        break;
      }
      case KeyCode.RIGHT_ARROW:
        e.preventDefault();
        this.handleRight();
        break;
      case KeyCode.SPACE_BAR:
        if (!this._isJumping) {
          this._isJumping = true;
          e.preventDefault();
          this.onJump.emit();
          break;
        }
    }
  }

  onKeyUp(e: KeyboardEvent) {
    var keycode: KeyCode = e.keyCode;
    switch (keycode) {
      case KeyCode.SPACE_BAR:
        this._isJumping = false;
        break;
    }
  }

  handleUp() {
    this.onFace._ = PlayerDirection.FACE_UP;
  }

  handleDown() {
    this.onFace._ = PlayerDirection.FACE_DOWN;
  }

  handleLeft() {
    switch (this.onFace._) {
      case PlayerDirection.FACE_UP:
        this.onFace._ = PlayerDirection.FACE_SLIGHT_LEFT;
        break;
      case PlayerDirection.FACE_LEFT:
        this.onFace._ = PlayerDirection.FACE_LEFT;
        break;
      case PlayerDirection.FACE_SLIGHT_LEFT:
        this.onFace._ = PlayerDirection.FACE_LEFT;
        break;
      case PlayerDirection.FACE_DOWN:
        this.onFace._ = PlayerDirection.FACE_SLIGHT_LEFT;
        break;
      case PlayerDirection.FACE_SLIGHT_RIGHT:
        this.onFace._ = PlayerDirection.FACE_DOWN;
        break;
      case PlayerDirection.FACE_RIGHT:
        this.onFace._ = PlayerDirection.FACE_SLIGHT_RIGHT;
        break;
    }
  }

  handleRight() {
    switch (this.onFace._) {
      case PlayerDirection.FACE_UP:
        this.onFace._ = PlayerDirection.FACE_SLIGHT_RIGHT;
        break;
      case PlayerDirection.FACE_LEFT:
        this.onFace._ = PlayerDirection.FACE_SLIGHT_LEFT;
        break;
      case PlayerDirection.FACE_SLIGHT_LEFT:
        this.onFace._ = PlayerDirection.FACE_DOWN;
        break;
      case PlayerDirection.FACE_DOWN:
        this.onFace._ = PlayerDirection.FACE_SLIGHT_RIGHT;
        break;
      case PlayerDirection.FACE_SLIGHT_RIGHT:
        this.onFace._ = PlayerDirection.FACE_RIGHT;
        break;
      case PlayerDirection.FACE_RIGHT:
        this.onFace._ = PlayerDirection.FACE_RIGHT;
        break;
    }
  }

  dispose() {
    this._onKeyDownSignal.dispose();
    this._onKeyUpSignal.dispose();
  }

  private _onKeyDownSignal: SignalConnection;
  private _onKeyUpSignal: SignalConnection;
  private _isJumping: boolean;
}

enum KeyCode {
  UP_ARROW = 38,
  DOWN_ARROW = 40,
  LEFT_ARROW = 37,
  RIGHT_ARROW = 39,
  SPACE_BAR = 32
}
